<div class="flex-container flex-container-left" [class.new-dashboard-layout]="isFlightSchoolUser || pilexosUser?.UserTypeId == PilexosUserTypeIds.pilotExaminer || pilexosUser?.UserTypeId == PilexosUserTypeIds.studentApplicant">
    <div class="top-container-body">
        <div class="top-item-container">
            <div class="top-text-container">
                <div [hidden]="true">
                    <button (click)="showSchoolRequestForm()">Request Flight School Setup</button>
                </div>
            </div>
            <div class="top-item-container">
                <ng-container *ngIf="pilexosUser">
                    <ng-container *ngIf="pilexosUser.UserTypeId == PilexosUserTypeIds.pilotExaminer">
                        <app-examiner-home></app-examiner-home>
                    </ng-container>
                    <ng-container *ngIf="pilexosUser.UserTypeId == PilexosUserTypeIds.studentApplicant">
                        <app-applicant-home></app-applicant-home>
                    </ng-container>
                    <ng-container *ngIf="isFlightSchoolUser">
                        <app-school-home></app-school-home>
                    </ng-container>
                </ng-container>
                <!-- <ng-container *ngIf="isPilexosAdmin">

                    <div dwRow>
                        <div dwCol="4">
                            <select [(ngModel)]="adminView" class="form-control">
                                <option value="examiner">Examiner View</option>
                                <option value="applicant">Applicant View</option>
                                <option value="flightSchool">Flight School</option>
                            </select>
                        </div>
                    </div>

                    <app-examiner-dashboard *ngIf="adminView == 'examiner'"></app-examiner-dashboard>

                    <app-applicant-dashboard *ngIf="adminView == 'applicant'"></app-applicant-dashboard>

                    <app-school-dashboard *ngIf="adminView == 'flightschool'"></app-school-dashboard>
                </ng-container> -->
            </div>
        </div>
    </div>
</div>
